import React, {Component} from "react";
import {Button, Form, Input} from "antd";
import IntlMessages from "util/IntlMessages";
import { auth } from "../firebase/firebase";
import { connect } from "react-redux";

const FormItem = Form.Item;


class ForgotPassword extends Component {

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        auth.sendPasswordResetEmail(values.email);
        this.props.history.push('/signin')
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <div className="gx-login-container">
        <div className="gx-login-content">

          <div className="gx-login-header">
            <img src={require("assets/images/logo-white.png")} alt="wieldy" title="wieldy"/>
          </div>
          <div className="gx-mb-4">
            <h2>Olvidaste tu contraseña ?</h2>
            <p><IntlMessages id="app.userAuth.forgot"/></p>
          </div>

          <Form layout="vertical" onSubmit={this.handleSubmit} className="gx-login-form gx-form-row0">

            <FormItem>
              {getFieldDecorator('email', {
                rules: [{
                  type: 'email', message: 'Por favor ingresa un correo valido!',
                }, {
                  required: true, message: 'Por favor ingresa un correo!',
                }],
              })(
                <Input type="email" placeholder="Correo electronico"/>
              )}
            </FormItem>

            <FormItem>
              <Button type="primary" htmlType="submit">
                Enviar
              </Button>
            </FormItem>
          </Form>

        </div>
      </div>
    );
  }
}

const WrappedForgotPasswordForm = Form.create()(ForgotPassword);

const mapStateToProps = ({routing}) => {
  return {
    routing,
  }
}

export default connect(mapStateToProps, {})(WrappedForgotPasswordForm);
